import React, { useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalBody, Text, Box } from '@chakra-ui/react';

interface AleaInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: React.ReactNode;
  width?: string | number; // default 400px
}

const AleaInfoModal: React.FC<AleaInfoModalProps> = ({ isOpen, onClose, message, width = '400px' }) => {
  // Lower header z-index while modal is open (keeps modal above header)
  useEffect(() => {
    try {
      const ev = new CustomEvent('alea-global-modal-open', { detail: isOpen });
      window.dispatchEvent(ev);
    } catch {}
    return () => {
      try {
        const ev = new CustomEvent('alea-global-modal-open', { detail: false });
        window.dispatchEvent(ev);
      } catch {}
    };
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay zIndex={1500} />
      <ModalContent
        zIndex={1501}
        width={width}
        minWidth={width}
        borderRadius="20px"
        bg="white"
      >
        <ModalBody p="0">
          <Box p="24px" textAlign="center">
            <Text fontSize="20px" fontWeight={500} color="#000">
              {message}
            </Text>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AleaInfoModal;


